export default function RegisterController() {

}